<template>
  <div id="ges-detail" class="d-flex">
    <MainBarMenuV2 />
    <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div>
    <div class="layout-content container-fluid mt-5">
      <div class="row p-2 mx-auto">
        <header-v2 :title="'Sistema de vigilancia epidemiológico'" />
        <div class="row w-100 mt-5">
          <div class="col-md-12">
            <div style="display: flex; left: 15px; margin-bottom: 10px">
              <label class="mr-2 breadcrumb-link"
                ><button
                  class="mt-0 p-0 pb-1 d-flex align-items-center breadcrumb-link back"
                  style="
                    border: none;
                    background-color: transparent;
                    font-size: 16px;
                  "
                  @click.prevent="backGes"
                >
                  Todos los Ges
                </button></label
              >
            </div>
            <div>
              <b-overlay :show="loading" rounded="sm">
                <template #overlay>
                  <OverlayButton clase="overlay-md"> </OverlayButton>
                </template>
                <info-ges
                  :getProcessingEmployees="getProcessingEmployees"
                  :isVisible="false"
                />
              </b-overlay>
            </div>
            <div class="mt-5">
              <h1
                style="
                  font-size: 16px !important;
                  color: #263238 !important;
                  text-transform: none !important;
                "
                class="mb-5"
              >
                Identificación de riesgo potencial tipo SVE {{ ges?.sve }}
              </h1>
              <b-overlay :show="loadingQuestion" rounded="sm">
                <template #overlay>
                  <OverlayButton clase="overlay-md"> </OverlayButton>
                </template>
                <b-tabs v-model="tabIndex" class="tabs-section-form-ipt mb-5">
                  <div class="card-form-section mt-5">
                    <b-tab title="Riesgo potencial">
                      <div>
                        <b-row class="mb-5">
                          <b-col cols="6">
                            <FormRiskComponent
                              :questions="questions"
                              :isBusy="isBusy"
                              @answerQuestion="answerQuestion"
                            />
                          </b-col>

                          <b-col cols="6">
                            <Textarea
                              label="Observaciones adicionales"
                              name="observation"
                              :rows="'16'"
                              :disabled="isBusy"
                              :value="formData.observations"
                              @input="
                                (event) =>
                                  (formData.observations = event.target.value)
                              "
                            />
                          </b-col>
                        </b-row>
                        <div class="mt-5 d-flex justify-content-end">
                          <button
                            class="button_primary"
                            @click.prevent="saveQuestion"
                            :disabled="isBusy || !isSave"
                          >
                            Guardar
                            <b-spinner v-if="isBusy" />
                          </button>
                        </div>
                      </div>
                    </b-tab>
                    <b-tab title="Información de personas">
                      <TableInfoPersonRisk />
                    </b-tab>
                    <b-tab title="Historial de modificaciones">
                      <TableHistory v-if="tabIndex === 2" />
                    </b-tab>
                  </div>
                </b-tabs>
              </b-overlay>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 3 MODAL PROCESO EXITOSO  -->
    <modal-success :messageModal="messageModal" />

    <!-- 4 MODAL PROCESO FALLIDO -->
    <modal-error :error="error" />
  </div>
</template>

<script>
import {
  getQuestionRisk,
  saveQuestionRisk,
  answersRisk,
  editQuestionRisk,
} from "@/services/health-tracker/ges/service";
import { mapGetters, mapActions, mapState } from "vuex";
import MainBarMenuV2 from "@/components/layouts/MainBarMenuV2.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
import InfoGes from "./components/detailGes/InfoGes.vue";
import FormRiskComponent from "./components/risk/FormRiskComponent";
import useInputs from "@/components/general/Inputs";
import ModalSuccess from "./modals/ModalSuccess.vue";
import ModalError from "./modals/ModalError.vue";
import TableInfoPerson from "./components/detailGes/TableInfoPerson.vue";
import TableInfoPersonRisk from "./components/risk/TableInfoPersonRisk";
import TableHistory from "./components/risk/TableHistory.vue";
const { Textarea } = useInputs();
export default {
  components: {
    HeaderV2: () => import("@/components/common/header/HeaderV2.vue"),
    MainBarMenuV2,
    HeadingUser,
    OverlayButton,
    FormRiskComponent,
    Textarea,
    InfoGes,
    ModalSuccess,
    ModalError,
    TableInfoPerson,
    TableInfoPersonRisk,
    TableHistory,
  },
  data() {
    return {
      id: this.$route.params.id,
      type: this.$route.params.type,
      category: this.$route.params.category,
      isEdit: this.$route.params.is_edit ? true : false,
      questions: [],
      questions2: [],
      loadingQuestion: true,
      isBusy: false,
      count: 1,
      tabIndex: 0,
      formData: {
        observations: "",
      },
      messageModal: "Riesgo Potencial guardado exitosamente",
      error: {
        message: "",
      },
    };
  },
  computed: {
    ...mapGetters("htGes", ["getProcessingEmployees"]),
    ...mapState("modSVE", ["ges", "loading"]),
    isSave() {
      const me = this;
      return me.answers.every((x) => x.answer != null);
    },
    answers() {
      const me = this;
      let answers = [];
      me.questions.forEach((x) => {
        answers.push(x.answers);
      });
      return answers;
    },
  },
  methods: {
    ...mapActions("modSVE", ["actGetGES"]),
    ...mapActions("htGes", ["indexEmployee", "updateStateEmployee"]),
    async getGes(id) {
      const me = this;
      me.updateStateEmployee();
      me.actGetGES(id).then(async () => {
        await me.indexEmployee({ id: me.ges.id });
      });
    },
    async loadQuestions() {
      const me = this;
      let questions = [];
      me.loadingQuestion = true;
      me.questions = [];
      me.questions2 = [];
      me.count = 1;
      try {
        const { data } = await getQuestionRisk(me.id);
        data.forEach((x) => {
          questions.push({
            id: x?.id,
            question: x?.question,
            sve_id: x?.sve_id,
            number: me.count++,
            answers: {
              question_id: x?.id,
              answer: null,
            },
          });
        });

        if (me.isEdit) {
          me.questions2 = questions;
        } else {
          me.questions = questions;
        }
      } catch (error) {
        console.log(error);
      } finally {
        me.loadingQuestion = me.isEdit ? true : false;
      }
    },
    async saveQuestion() {
      const me = this;
      me.isBusy = true;
      const formData = {};

      if (me.formData.observations)
        formData.observations = me.formData.observations;

      const option = me.isEdit ? editQuestionRisk : saveQuestionRisk;
      try {
        await option(me.id, {
          ...formData,
          answers: me.answers,
        });
        me.$bvModal.show("modal-success");
        setTimeout(() => {
          me.backGes();
        }, 5000);
      } catch (error) {
        me.error.message = "Error al guardar Formulario";
        me.$bvModal.show("modal-fail");
      } finally {
        me.isBusy = false;
      }
    },
    async loadAnswers() {
      const me = this;
      me.loadingQuestion = true;
      try {
        const { data } = await answersRisk(me.id);
        me.questions2.forEach((x) => {
          const record = data.find((y) => y.id == x.id);
          if (record) {
            const result = record?.answer?.answer == 1 ? "1" : "0";
            x.answer = result;
            x.answers.answer = result;
          }
        });
        me.questions = me.questions2;
      } catch (error) {
        console.log(error);
      } finally {
        me.loadingQuestion = false;
      }
    },
    answerQuestion(value) {
      const me = this;
      me.questions.forEach((x) => {
        if (x.id === value.id) {
          x.answers.answer = value?.value;
        }
      });
    },
    backGes() {
      const me = this;
      me.$router.push({
        name: "sve",
        params: {
          category: me.category,
          type: me.type,
        },
      });
    }
  },
  async mounted() {
    const me = this;
    me.getGes(me.id);
    await me.loadQuestions();
    if (me.isEdit) me.loadAnswers();
  },
};
</script>

<style lang="scss">
.tabs-section-form-ipt div:first-child {
  text-align: center;
}
.tabs-section-form-ipt .nav-tabs {
  background: white !important;
  padding: 4px !important;
  border-radius: 30px !important;
  align-items: center !important;
  border: 1px solid #c9caff !important;
  display: inline-flex !important;
  // width: 100% !important;
}

.tabs-section-form-ipt .nav-tabs li {
  width: 100% !important;
}

.tabs-section-form-ipt .nav-tabs .nav-item a {
  color: #546e7a !important;
  font-weight: 700 !important;
  margin-bottom: 0 !important;
}

.tabs-section-form-ipt .nav-tabs .nav-item a {
  border: none !important;
}

.tabs-section-form-ipt .nav-tabs .nav-item a.active {
  background-color: #5d5fef !important;
  color: white !important;
  padding: 8px 16px 8px 16px !important;
  border-radius: 30px !important;
  border-bottom: 0 !important;
}
.card-form-section {
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #cfd8dc;
}
</style>
